import React, { useState, useContext } from "react";
import { Button, Row, Col, Typography, Image, message } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import { DateFormat, saveApi } from "../../../helpers";
import Sidebar from "../../../components/Sidebar";
import UploadImage from "../../../components/UploadImage";
import Popup from "../../../components/Popup";
import { StoreContext } from "../../../context";

export default function OfferSidebar({
  visible = false,
  data = {},
  onClose,
  editOfferHandler,
  onUploadDone,
}) {
  const { storeId } = useContext(StoreContext);
  const [loading, setLoading] = useState(false);
  const [deleteImagePopup, setDeleteImagePopup] = useState(false);

  const deleteImageHandler = async () => {
    if (data.offer_image_id) {
      setDeleteImagePopup(false);
      setLoading(true);
      const res = await saveApi(
        { offer_image_id: data.offer_image_id },
        "Offer Image Deleted",
        "deleteOfferImage"
      );
      if (res) {
        onUploadDone();
      } else {
        setLoading(false);
      }
    }
  };

  return (
    <>
      {deleteImagePopup && (
        <Popup
          saveText="Yes, Delete"
          title="Delete Offer Image"
          saveHandler={deleteImageHandler}
          visible={deleteImagePopup}
          cancelHandler={() => setDeleteImagePopup(false)}
        >
          <Typography.Title style={{ fontSize: 18 }}>
            Are you sure to delete the Image ?
          </Typography.Title>
          <Typography.Text type="danger">
            This action cannot be reverted.
          </Typography.Text>
        </Popup>
      )}
      <Sidebar
        title="Offer Details"
        visible={visible}
        onClose={onClose}
        loading={loading}
        footer={
          !storeId && (
            <div style={{ textAlign: "right" }}>
              <Button
                icon={<EditOutlined />}
                onClick={editOfferHandler}
                type="primary"
              >
                Edit Offer Details
              </Button>
            </div>
          )
        }
      >
        <Row>
          <Col span={12}>
            <Row>
              <Col className="lblc" xs={24}>
                <Typography.Text style={{ fontSize: 11 }} type="secondary">
                  Name
                </Typography.Text>
                <br />
                <Typography.Text>{data.name}</Typography.Text>
              </Col>
              <Col className="lblc" xs={24}>
                <Typography.Text style={{ fontSize: 11 }} type="secondary">
                  Coupon Code
                </Typography.Text>
                <br />
                <Row gutter={0}>
                  <div
                    style={{
                      color: "#17CC73",
                      border: "2.5px dashed #808080",
                      textTransform: "uppercase",
                      padding: "5px 10px",
                    }}
                  >
                    {data.coupon_code}
                  </div>
                </Row>
              </Col>
              <Col className="lblc" xs={24}>
                <Typography.Text style={{ fontSize: 11 }} type="secondary">
                  Date
                </Typography.Text>
                <br />
                <Typography.Text>{DateFormat(data.created_at)}</Typography.Text>
              </Col>
            </Row>
          </Col>
          <Col style={{ textAlign: "right", paddingRight: 25 }} span={12}>
            {data.offer_image ? (
              <>
                {!storeId && (
                  <div style={{ marginBottom: 10 }}>
                    <Button
                      onClick={() => setDeleteImagePopup(true)}
                      size="small"
                    >
                      <Typography.Text style={{ color: "#17CC73" }}>
                        <DeleteOutlined /> Delete Image
                      </Typography.Text>
                    </Button>
                  </div>
                )}
                <Image width={140} src={data.offer_image} />
              </>
            ) : !storeId && (
              <UploadImage
                onUploadDone={onUploadDone}
                type_id={data.id}
                type="offer"
                apiName="uploadOfferImage"
                title="Add Offer Image"
                setLoading={setLoading}
              />
            )}
          </Col>
          {(data.category_id || data.variant_id) && (
            <Col className="lblc" xs={24}>
              <Typography.Text style={{ fontSize: 11 }} type="secondary">
                Offer On
              </Typography.Text>
              <br />
              <Typography.Text>
                {data.variant_id
                  ? "Product : " +
                    (data.product_name ? data.product_name + " - " : "") +
                    data.variant_name
                  : "Category : " + data.category_name}
              </Typography.Text>
            </Col>
          )}
          <Col className="lblc" xs={24}>
            <Typography.Text style={{ fontSize: 11 }} type="secondary">
              Offer
            </Typography.Text>
            <br />
            <Typography.Text>
              {data.percent_discount
                ? data.percent_discount + " % Off"
                : data.amount_discount
                ? "₹ " + data.amount_discount + " Off"
                : "Freebie - 100 % Off"}
            </Typography.Text>
            {data.upto && (
              <>
                <br />
                <Typography.Text type="secondary">
                  Max Discount :{" "}
                </Typography.Text>
                <Typography.Text strong> ₹ {data.upto}</Typography.Text>
              </>
            )}
            {data.min_amount && (
              <>
                <br />
                <Typography.Text type="secondary">
                  Min Order Amount :{" "}
                </Typography.Text>
                <Typography.Text strong> ₹ {data.min_amount}</Typography.Text>
              </>
            )}
          </Col>
          <Col className="lblc" xs={24}>
            <Typography.Text style={{ fontSize: 11 }} type="secondary">
              Validity
            </Typography.Text>
            <br />
            <Typography.Text>
              {DateFormat(data.valid_from, "DD MMM YY")} -{" "}
              {DateFormat(data.valid_till, "DD MMM YY")}
            </Typography.Text>
          </Col>
          {data.tag_id && (
            <Col className="lblc" xs={24}>
              <Typography.Text style={{ fontSize: 11 }} type="secondary">
                Tag
              </Typography.Text>
              <br />
              <Typography.Text>{data.tag_name}</Typography.Text>
            </Col>
          )}
          <Col className="lblc" xs={24}>
            <Typography.Text style={{ fontSize: 11 }} type="secondary">
              Description
            </Typography.Text>
            <br />
            <Typography.Text>{data.description}</Typography.Text>
          </Col>
        </Row>
      </Sidebar>
    </>
  );
}
